import e from "../managers/braze-instance.js";
import v from "./content-cards-provider.js";
const g = {
  t: !1,
  provider: null,
  er: () => (
    g.o(),
    g.provider ||
      ((g.provider = new v(e.ir(), e.l(), e.tr(), e.nr(), e.ar())),
      e.dr(g.provider)),
    g.provider
  ),
  o: () => {
    g.t || (e.g(g), (g.t = !0));
  },
  destroy: () => {
    (g.provider = null), (g.t = !1);
  },
};
export default g;
